export default __webpack_public_path__ + "static/media/nftbonus.a1070ed0.png";